const translations: Record<string, string> = {
  "ak_scada2_running": "у роботі",
  "ak_scada2_no_generation": "без генерації",
  "ak_scada2_warning": "попередження",
  "ak_scada2_alarm": "аварія",
  "ak_scada2_data_is_getting_stale": "дані застарівають",
  "ak_scada2_no_link": "немає звʼязку",
  "ak_scada2_no_data": "немає даних",
  "ak_scada2_bus_i_section_d1": "І СШ · секція D1",
  "ak_scada2_bus_ii_section_d2": "ІІ СШ · секція D2",
  "ak_scada2_kw": "кВт",
  "ak_scada2_of": " з {{n}}",
  "ak_scada2_undetermined": " · невизначено: {{n}}",
  "ak_scada2_inverter": "Інвертор",
  "ak_scada2_breaker": "вимикач",
  "ak_scada2_hz": "Гц",
  "ak_scada2_ezlogger_from_the_station_network": "EzLogger {{ip}} — з мережі станції",
  "ak_scada2_per_the_addressing_table": "{{n}} за адресною відомістю · {{src}}",
  "ak_scada2_deviations": "Відхилення ({{n}})",
  "ak_scada2_the_collector_returns_unit_ids_that_ar": "Колектор віддає Unit ID, яких немає в адресній відомості: {{ids}}.",
  "ak_scada2_breakers_qf_in_bus_order": "· вимикачі {{n}}.QF, по порядку на шині",
  "ak_scada2_close": "Закрити",
  "ak_scada2_of_nominal": "Від номіналу",
  "ak_scada2_frequency": "Частота",
  "ak_scada2_last_data": "Останні дані",
  "ak_scada2_none": "немає",
  "ak_scada2_status_raw": "Стан (сирий)",
  "ak_scada2_model": "Модель",
  "ak_scada2_s_n_per_spec": "S/N за ТЗ",
  "ak_scada2_logger": "Логер",
  "ak_scada2_plc_channel": "Канал PLC",
  "ak_scada2_factory_interface": "Заводський інтерфейс",
  "ak_scada2_power_per_day_kw": "Потужність за добу, кВт",
  "ak_scada2_no_daily_data_for_this_inverter": "Добових даних для цього інвертора немає",
  "ak_scada2_loading": "Завантаження…",
  "ak_scada2_inverters": "Інвертори",
  "ak_scada2_inverters_by_ktp_and_section": "Інвертори за КТП і секціями",
  "ak_scada2_all_ktp": "Усі КТП",
  "ak_scada2_all": "Усі",
  "ak_scada2_search_45_u_2_qf6_s_n": "Пошук: 45.U, 2.QF6, S/N",
  "ak_scada2_inverter_search": "Пошук інвертора",
  "ak_scada2_the_last_poll_failed_the_previous_snap": "Останнє опитування не вдалося — показано попередній знімок; його вік видно в деталях інвертора.",
  "ak_scada2_no_inverters_match_the_filter": "Немає інверторів за фільтром.",
  "ak_scada2_value_from_a_stale_snapshot_not_includ": "· «~» — значення із застарілого знімка, до сум не входить",
  "ak_scada2_off": "вимкнено",
  "ak_scada2_standby": "очікування",
  "ak_scada2_charging": "заряд",
  "ak_scada2_discharging": "розряд",
  "ak_scada2_running_2": "робота",
  "ak_scada2_normal": "норма",
  "ak_scada2_racks": "стійки {{r}} · {{ip}}",
  "ak_scada2_limit_kw_heatsink": "межа ±{{a}} кВт · радіатор {{b}}°",
  "ak_scada2_battery": "Батарея",
  "ak_scada2_cell_spread": "розкид комірок",
  "ak_scada2_mv": "мВ",
  "ak_scada2_pack": "пакет",
  "ak_scada2_v": "В",
  "ak_scada2_the_collector_groups_this_battery_with": "Колектор групує цю батарею з {{p}}, а ТЗ — з {{a}}, {{b}}.",
  "ak_scada2_4_blocks_2_batteries_pcs_a_b_sign_disc": "4 блоки × 2 батареї × PCS A/B · знак: + розряд, − заряд · {{c}}, {{a}}",
  "ak_scada2_batteries": "батарей",
  "ak_scada2_alarms": " · аварій {{n}}",
  "ak_scada2_kwh": "кВт·год",
  "ak_scada2_kw_of": "кВт з",
  "ak_scada2_the_collector_does_not_yet_collect_soc": "SOC окремих груп стійок 1–6 / 7–11 колектор поки не збирає (порти стійок 503–513 SCU) — показано SOC батареї загалом. Помилки окремих стійок і вмикання окремого PCS — у заводських інтерфейсах Jinko ESMS і Kehua, з мережі станції.",
  "ak_scada2_no_data_from_the_collector": "немає даних від колектора",
  "ak_scada2_active_pcs_alarm": "Активна аварія PCS. ",
  "ak_scada2_the_pcs_of_the_pair_operate_in_opposit": "PCS пари працюють у протилежних напрямках — порушення правила спільного напрямку. ",
  "ak_scada2_bess_data_is_currently_unavailable": "Дані УЗЕ зараз недоступні.",
  "ak_scada2_bess_by_equipment": "УЗЕ за обладнанням",
  "ak_scada2_bess_power": "Потужність УЗЕ",
  "ak_scada2_system_soc": "SOC системи",
  "ak_scada2_can_charge": "Можна зарядити",
  "ak_scada2_can_discharge": "Можна розрядити",
  "ak_scada2_vs_med": "{{s}}{{d}}% до мед.",
  "ak_scada2_running_median": "{{w}}/{{n}} у роботі · медіана {{m}}%",
  "ak_scada2_running_total_mw": "· {{a}}/{{e}} у роботі · сумарно {{p}} МВт",
  "ak_scada2_max_spread": "макс. розрив {{n}}%",
  "ak_scada2_weakest_typical_strongest": "найслабший {{a}}%  ·  типовий {{b}}%  ·  найсильніший {{c}}%",
  "ak_scada2_offline": "офлайн",
  "ak_scada2_estimate": "оцінка",
  "ak_scada2_nom": "% номін.",
  "ak_scada2_inverter_technical_status": "Технічний стан інверторів",
  "ak_scada2_each_inverter_power_of_nominal_deviati": "Кожен інвертор: потужність, % від номіналу, відхилення від медіани групи",
  "ak_scada2_station_inverter_fleet_status": "Стан інверторного парку станції",
  "ak_scada2_no_inverter_data_for_this_station": "Немає даних по інверторах для цієї станції.",
  "ak_scada2_the_controller_sends_totals_only_no_pe": "контролер передає лише сумарні дані — розбивки по інверторах немає",
  "ak_scada2_station_power_per_day": "Потужність станції за добу",
  "ak_scada2_inverter_uniformity_per_day": "Рівномірність роботи інверторів за добу",
  "ak_scada2_total_station_power_aggregated_meterin": "Сумарна потужність станції (агрегований облік — розподіл по інверторах недоступний)",
  "ak_scada2_green_line_the_typical_average_inverte": "Зелена лінія — типовий (середній) інвертор; смуга — розрив між найсильнішим і найслабшим. Вузька смуга = усі працюють однаково, ширша = якийсь інвертор відстає.",
  "ak_scada2_no_data_for_today": "Немає даних за сьогодні.",
  "ak_scada2_time_of_day": "Час доби",
  "ak_scada2_of_nominal_2": "% від номіналу",
  "ak_scada2_power": "Потужність",
  "ak_scada2_spread": "Розкид",
  "ak_scada2_median": "Медіана",
  "ak_scada2_the_station_controller_sends_only_a_to": "Контролер станції передає лише сумарний показник, тому стан кожного інвертора окремо недоступний. Кількість у роботі береться з лічильника контролера.",
  "ak_scada2_inverters_running": "Інвертори ({{w}}/{{n}} у роботі)",
  "ak_scada2_median_2": "медіана {{m}}%",
  "ak_scada2_lagging_behind_the_group": "Відстають від групи:",
  "ak_scada2_vs_median": "{{s}}{{d}}% до медіани",
  "ak_scada2_inv_details": "INV-{{n}} — деталі",
  "ak_scada2_updated": "оновлено {{t}}",
  "ak_scada2_inverter_data_is_not_available_for_thi": "Дані по інверторах недоступні для цієї станції.",
  "ak_scada2_aggregated_metering_per_inverter_data": "Агрегований облік — дані по окремих інверторах не передаються",
  "ak_scada2_heat_map_by_deviation_from_the_group_m": "Теплова мапа за відхиленням від медіани групи · натисніть інвертор для деталей",
  "ak_scada2_all_inverters_are_within_the_norm_rela": "Усі інвертори в межах норми відносно групи.",
  "ak_scada2_normal_3": "в нормі (≥ −3%)",
  "ak_scada2_below_3_10": "нижче (−3…−10%)",
  "ak_scada2_lagging_10": "відстає (< −10%)",
  "ak_scada2_phase": "Фаза",
  "ak_scada2_voltage_v": "Напруга, В",
  "ak_scada2_current_a": "Струм, А",
  "ak_scada2_power_kw": "Потужність, кВт",
  "ak_scada2_phase_voltage_per_day_v": "Напруга фаз за добу, В",
  "ak_scada2_phase_current_per_day_a": "Струм фаз за добу, А",
  "ak_scada2_mw": "МВт",
  "ak_scada2_kv": "кВ",
  "ak_scada2_a": "А",
  "ak_scada2_strings": "стрінги {{a}}/{{b}}",
  "ak_scada2_strings_ok": "{{id}} · стрінги ({{a}}/{{b}} в нормі)",
  "ak_scada2_group_load": "Завантаженість групи",
  "ak_scada2_running_3": "В роботі",
  "ak_scada2_voltage_u": "Напруга U",
  "ak_scada2_current_i": "Струм I",
  "ak_scada2_temperature_t": "Температура T",
  "ak_scada2_bess": "УЗЕ / BESS",
  "ak_scada2_standby_2": "очікує",
  "ak_scada2_mode": "Режим",
  "ak_scada2_point_of_connection": "Точка приєднання",
  "ak_scada2_limit": "Ліміт",
  "ak_scada2_inverter_2": "Інвертор {{id}}",
  "ak_scada2_storage": "Накопичувач • {{m}}",
  "ak_scada2_inverters_running_2": "{{w}}/{{t}} інверторів у роботі",
  "ak_scada2_voltage": "Напруга",
  "ak_scada2_current": "Струм",
  "ak_scada2_temperature": "Температура",
  "ak_scada2_efficiency": "ККД",
  "ak_scada2_bess_2": "УЗЕ",
  "ak_scada2_charge": "Заряд",
  "ak_scada2_charging_power": "Потужність заряду",
  "ak_scada2_discharging_power": "Потужність розряду",
  "ak_scada2_health": "Ресурс",
  "ak_scada2_groups": "Груп",
  "ak_scada2_group": "Група {{n}}",
  "ak_scada2_discharge": "Розряд",
  "ak_scada2_alarm_2": "Аварія",
  "ak_scada2_standby_3": "Очікування",
  "ak_scada2_inverters_2": "інверторів",
  "ak_scada2_more": "ще {{n}}",
};

export default translations;
